import api from "./api";
import { normalizePhoneForApi } from "../utils/phone";

const AUTH_URL = "/auth";

const storeUser = (userData) => {
  const { password, ...safeUser } = userData;
  localStorage.setItem("user", JSON.stringify(safeUser));
  return safeUser;
};

const getErrorMessage = (error) => {
  const data = error.response?.data;
  if (typeof data === "string") return data;
  if (data?.message) return data.message;
  return "Request failed";
};

const sendOtp = (phone, purpose) => {
  return api
    .post(
      `${AUTH_URL}/send-otp`,
      { phone: normalizePhoneForApi(phone), purpose },
      { skipAuth: true }
    )
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(getErrorMessage(error));
    });
};

const verifyOtp = (phone, otp, purpose) => {
  return api
    .post(
      `${AUTH_URL}/verify-otp`,
      { phone: normalizePhoneForApi(phone), otp, purpose },
      { skipAuth: true }
    )
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(getErrorMessage(error));
    });
};

const signup = (userData) => {
  return api
    .post(
      `${AUTH_URL}/signup`,
      {
        ...userData,
        phone: normalizePhoneForApi(userData.phone),
      },
      { skipAuth: true }
    )
    .then((response) => {
      if (response.data.token) {
        return storeUser(response.data);
      }
      return response.data;
    })
    .catch((error) => {
      throw new Error(getErrorMessage(error));
    });
};

const login = (phone, password) => {
  return api
    .post(
      `${AUTH_URL}/login`,
      {
        phone: normalizePhoneForApi(phone),
        password,
      },
      { skipAuth: true }
    )
    .then((response) => {
      if (response.data.token) {
        return storeUser(response.data);
      }
      return response.data;
    })
    .catch((error) => {
      throw new Error(getErrorMessage(error));
    });
};

const forgotPassword = (phone) => {
  return api
    .post(
      `${AUTH_URL}/forgot-password`,
      { phone: normalizePhoneForApi(phone) },
      { skipAuth: true }
    )
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(getErrorMessage(error));
    });
};

const resetPassword = (phone, otp, newPassword) => {
  return api
    .post(
      `${AUTH_URL}/reset-password`,
      {
        phone: normalizePhoneForApi(phone),
        otp,
        newPassword,
      },
      { skipAuth: true }
    )
    .then((response) => {
      if (response.data.token) {
        return storeUser(response.data);
      }
      return response.data;
    })
    .catch((error) => {
      throw new Error(getErrorMessage(error));
    });
};

const logout = () => {
  return api
    .post(`${AUTH_URL}/logout`, {}, { skipAuth: true })
    .catch(() => null)
    .finally(() => {
      localStorage.removeItem("user");
    });
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem("user"));
};

const authService = {
  sendOtp,
  verifyOtp,
  signup,
  login,
  forgotPassword,
  resetPassword,
  logout,
  getCurrentUser,
};

export default authService;
